import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import SelectionList from '@vfgroup-oneplatform/foundation/Components/SelectionList';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';

import styles from './PaymentAndDelivery.Styles';

const DELIVERY_OPTIONS_TYPES = {
  DELIVERY: 'delivery',
  IN_STORE_PICKUP: 'in_store_pickup',
};
const getPaymentMethodsOptions = paymentMethods => {
  return _map(paymentMethods, payment => {
    const { cardName, lastFourDigits } = payment;
    return {
      title: cardName,
      subTitle:
        ContentManager.translate('device_upgrade_summary_step_payment_card_ending') +
        ' ' +
        lastFourDigits,
    };
  });
};
const getDeliveryAddressesOptions = deliveryAddresses => {
  return _map(deliveryAddresses, address => {
    const { houseOrFlat, streetName } = address;
    return {
      title: houseOrFlat,
      subTitle: streetName,
    };
  });
};
const getDeliveryOptions = deliveryOptions => {
  return _map(deliveryOptions, option => {
    const { name, days } = option;
    return {
      ...option,
      title: name,
      subTitle: days,
    };
  });
};
const PaymentAndDelivery = ({
  paymentMethods = [],
  deliveryOptions,
  deliveryAddresses = [],
  selectedPaymentMehtodIndex,
  selectedDeliveryOptionIndex,
  selectedDeliveryAddressIndex,
  selectedDeliveryOption = {},
  onPaymentAndDeliveryOptionChange,
  isPaymentMethodsLoading,
  isDeliveryAddressesLoading,
}) => {
  const theme = useTheme();

  if (isPaymentMethodsLoading || isDeliveryAddressesLoading) {
    return null;
  }

  return (
    <View>
      <VFText
        style={styles.headline}
        i18nKey={'device_upgrade_summary_step_payment_and_delivery'}
      />

      <VFText
        type={'primary'}
        style={styles.selectionTitle}
        i18nKey={'device_upgrade_summary_step_payment_method'}
      />
      <SelectionList
        activeTitleStyle={styles.titleStyle(theme)}
        inActiveTitleStyle={styles.titleStyle(theme)}
        inActiveSubtitleStyle={styles.subtitleStyle(theme)}
        activeSubtitleStyle={styles.subtitleStyle(theme)}
        options={getPaymentMethodsOptions(paymentMethods)}
        itemContainerStyle={styles.optionContainer}
        initialSelectedIndex={selectedPaymentMehtodIndex}
        onSelectOption={(index, option) => {
          onPaymentAndDeliveryOptionChange('selectedPaymentMehtodIndex', index);
        }}
      />
      <VFText
        type={'primary'}
        style={styles.selectionTitle}
        i18nKey={'device_upgrade_summary_step_delivery_options'}
      />
      <SelectionList
        activeTitleStyle={styles.titleStyle(theme)}
        inActiveTitleStyle={styles.titleStyle(theme)}
        inActiveSubtitleStyle={styles.subtitleStyle(theme)}
        activeSubtitleStyle={styles.subtitleStyle(theme)}
        options={getDeliveryOptions(deliveryOptions)}
        itemContainerStyle={[styles.optionContainer, styles.halfWidthOption]}
        initialSelectedIndex={selectedDeliveryOptionIndex}
        onSelectOption={(index, option) => {
          if (option.type == DELIVERY_OPTIONS_TYPES.IN_STORE_PICKUP) {
            onPaymentAndDeliveryOptionChange('selectedDeliveryAddressIndex', -1);
          } else {
            onPaymentAndDeliveryOptionChange('selectedDeliveryAddressIndex', 0);
          }
          onPaymentAndDeliveryOptionChange('selectedDeliveryOptionIndex', index);
        }}
      />

      <View
        style={styles.sectionOpacity(
          selectedDeliveryOption.type == DELIVERY_OPTIONS_TYPES.IN_STORE_PICKUP ? 0 : 1,
        )}
      >
        <VFText
          type={'primary'}
          style={styles.selectionTitle}
          i18nKey={'device_upgrade_summary_step_delivery_address'}
        />
        <SelectionList
          activeTitleStyle={styles.titleStyle(theme)}
          inActiveTitleStyle={styles.titleStyle(theme)}
          inactiveSubtitleStyle={styles.subtitleStyle(theme)}
          activeSubtitleStyle={styles.subtitleStyle(theme)}
          options={getDeliveryAddressesOptions(deliveryAddresses)}
          itemContainerStyle={styles.optionContainer}
          initialSelectedIndex={selectedDeliveryAddressIndex}
          onSelectOption={(index, option) => {
            onPaymentAndDeliveryOptionChange('selectedDeliveryAddressIndex', index);
          }}
        />
      </View>
    </View>
  );
};
PaymentAndDelivery.propTypes = {
  paymentMethods: PropTypes.array,
  deliveryOptions: PropTypes.array,
  deliveryAddresses: PropTypes.array,
  isPaymentMethodsLoading: PropTypes.bool,
  isDeliveryAddressesLoading: PropTypes.bool,
  selectedPaymentMehtodIndex: PropTypes.number,
  selectedDeliveryOptionIndex: PropTypes.number,
  selectedDeliveryAddressIndex: PropTypes.number,
  selectedDeliveryOption: PropTypes.object,
  onPaymentAndDeliveryOptionChange: PropTypes.func,
};
export {
  DELIVERY_OPTIONS_TYPES,
  getPaymentMethodsOptions,
  getDeliveryAddressesOptions,
  getDeliveryOptions,
};
export default PaymentAndDelivery;
